import React from "react";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";

const IconCircleButton = ({ icon, onClick, size = 30, color = "primary", sx = {} }) => {
  return (
    <Button
      variant="contained"
      color={color}
      onClick={onClick}
      sx={{
        width: size,
        height: size,
        minWidth: 0,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        ...sx,
      }}
    >
      <Add />
    </Button>
  );
};

export default IconCircleButton;